import { Profile } from '../Components/Common/Profile'

export const sharedRoutes = [
	// Common routes that might be used by multiple roles
	{ path: `${process.env.PUBLIC_URL}/profile/:layout`, Component: <Profile /> }
	// { path: `${process.env.PUBLIC_URL}/shared/settings/:layout`, Component: <UserSettings /> },
]
